module.exports = __webpack_public_path__ + "static/img/clothes.1d5f4f0d.png";